import { BoundNumberField, BoundTextField, Css, IconButton } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { BoundScheduleFlagReasonSelects } from "src/routes/projects/dynamic-schedules/components/BoundScheduleFlagReasonSelects";
import { ScheduleFlagReasonDetailFragment } from "src/routes/projects/schedule-v2/detail-pane/scheduleFlags/ScheduleFlags.generated";
import { ScheduleFlagFormConfig } from "./ScheduleFlag";

type ScheduleFlagFormProps = {
  formState: ObjectState<ScheduleFlagFormConfig>;
  reasons: ScheduleFlagReasonDetailFragment[];
  onClose?: () => void;
};
export function ScheduleFlagForm({ formState, reasons, onClose }: ScheduleFlagFormProps) {
  return (
    <div css={Css.df.fdc.gap1.$}>
      <div css={Css.df.jcc.aifs.gap1.my2.$}>
        <div css={Css.fg1.df.gap1.$}>
          <BoundScheduleFlagReasonSelects formState={formState} scheduleFlagReasons={reasons} />
        </div>
        <div>
          <BoundNumberField
            label="Duration"
            labelStyle="above"
            type="days"
            xss={Css.tal.jcfs.$}
            field={formState.durationInDays}
            readOnly={true}
            positiveOnly
          />
        </div>
        {onClose && (
          <div css={Css.pt3.$}>
            <IconButton icon="x" onClick={onClose} />
          </div>
        )}
      </div>
      <BoundTextField label="Description (Optional)" field={formState.description} labelStyle="above" />
    </div>
  );
}
